module.exports = __webpack_public_path__ + "img/appstore_menu.a0e72f5c.png";